import Logger from '@/lib/logger';

const toCamelCase = (str) => {
  if (!str) return '';
  return str
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
      index === 0 ? word.toLowerCase() : word.toUpperCase()
    )
    .replace(/\s+/g, '');
};

export const state = {
  delinquencyFeatures: null,
};

export const mutations = {
  SET_DELINQUENCY_FEATURES(state, features) {
    state.delinquencyFeatures = features;
  },
  CLEAR_FEATURES(state) {
    state.delinquencyFeatures = null;
  },

  PROCESS_DELINQUENCY_FEATURES(state, allClientModules) {
    if (!Array.isArray(allClientModules)) {
        state.delinquencyFeatures = {};
        return;
    }

    const delinquencyModuleData = allClientModules.find(
      (module) => module.appName === 'Delinquency-Pro'
    );

    if (delinquencyModuleData && Array.isArray(delinquencyModuleData.features)) {
      const featuresObject = delinquencyModuleData.features.reduce((acc, feature) => {
        const featureKey = toCamelCase(feature.name);
        acc[featureKey] = feature.isActive;
        return acc;
      }, {});
      
      state.delinquencyFeatures = featuresObject;

    } else {
      state.delinquencyFeatures = {};
      Logger.warn('Delinquency-Pro module data or its features were not found.');
    }
  }
};

export const actions = {
  clearFeatureFlags({ commit }) {
    commit('CLEAR_FEATURES');
  },
};

export const getters = {
  delinquencyFeatures: (state) => state.delinquencyFeatures,
  isFeatureEnabled: (state) => (featureKey) => {
    return !!(state.delinquencyFeatures && state.delinquencyFeatures[featureKey]);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};